class SectionHeader extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  connectedCallback() {
    this.setupElements();
    this.setupEventListeners();
    this.setupResizeObserver();
    this.updateLogoVisibility();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  init() {
    this.boundUpdateLogoVisibility = this.updateLogoVisibility.bind(this);
    this.boundUpdateLargeLogoHeight = this.updateLargeLogoHeight.bind(this);
    this.resizeObserver = null;
  }

  setupElements() {
    this.logoLarge = this.querySelector('.header__logo--large');
    this.logoDefault = this.querySelector('.header__logo--default');
    
    if (!this.logoLarge || !this.logoDefault) {
      console.warn('Logo elements not found');
      return;
    }
  }

  setupEventListeners() {
    window.addEventListener('scroll', this.boundUpdateLogoVisibility, { passive: true });
  }

  setupResizeObserver() {
    if (!this.logoLarge) return;

    // Stop any existing observer
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    // Create new observer for the parent element
    this.resizeObserver = new ResizeObserver(entries => {
      if (!entries.length) return;
      this.boundUpdateLargeLogoHeight();
    });

    // Start observing the parent element
    const images = this.logoLarge.querySelectorAll('.header__logo--image img');
    if (!images.length) return;

    const visibleImage = Array.from(images).find(image => 
      window.getComputedStyle(image).display !== 'none'
    );

    if (visibleImage) {
      this.resizeObserver.observe(visibleImage);
      // Initial height update
      this.boundUpdateLargeLogoHeight();
    }
  }

  updateLargeLogoHeight() {
    if (!this.logoLarge) return;
    const images = this.logoLarge.querySelectorAll('.header__logo--image img');

    if (!images.length) return;

    const visibleImage = Array.from(images).find(image => 
      window.getComputedStyle(image).display !== 'none'
    );

    if (!visibleImage) return;
    
    const imageHeight = visibleImage.offsetHeight + 15; // + 15px margin-bottom
    
    if (imageHeight > 0 && !this.logoLarge.classList.contains('hidden-logo')) {
      this.logoLarge.style.height = `${imageHeight}px`;
    }
  }

  updateLogoVisibility() {
    if (!this.logoLarge || !this.logoDefault) return;

    const isAtTop = window.scrollY <= 5;
    const isLargeLogoVisible = !this.logoLarge.classList.contains('hidden-logo');

    // Only update if state is changing
    if ((isAtTop && !isLargeLogoVisible) || (!isAtTop && isLargeLogoVisible)) {
      if (isAtTop) {
        this.showLargeLogo();
      } else {
        this.hideLargeLogo();
      }
    }
  }

  showLargeLogo() {
    this.logoLarge.classList.remove('hidden-logo');
    this.logoDefault.classList.add('hidden-logo');
    // Update height after the element is shown
    requestAnimationFrame(() => this.updateLargeLogoHeight());
  }

  hideLargeLogo() {
    this.logoLarge.classList.add('hidden-logo');
    this.logoDefault.classList.remove('hidden-logo');
    this.logoLarge.style.height = 0;
  }

  cleanup() {
    window.removeEventListener('scroll', this.boundUpdateLogoVisibility, { passive: true });
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}

// Only define the custom element if it hasn't been defined already
if (!customElements.get('section-header')) {
  customElements.define('section-header', SectionHeader);
}